import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'filePreview',
  standalone: true,
})
export class FilePreviewPipe implements PipeTransform {
  transform(file: File | string | null): string {
    if (!file) {
      return '/images/default-placeholder.png';
    }

    if (typeof file === 'string') {
      const TRIMMED = file.trim();

      if (TRIMMED.startsWith('http://') || TRIMMED.startsWith('https://')) {
        return TRIMMED;
      }

      if (TRIMMED.startsWith('data:image/')) {
        return TRIMMED;
      }

      return '/images/default-placeholder.png';
    }

    // If it's a File object
    return URL.createObjectURL(file);
  }
}
